import { AdminDashboardLayout } from '@/features/admin/layouts/AdminDashboardLayout';
import { AdminDashboardPage } from '@/features/admin/pages/AdminDashboardPage';
import { AdminGuideOnboardingPage } from '@/features/admin/pages/AdminGuideOnboardingPage';
import { AdminGuideReviewPage } from '@/features/admin/pages/AdminGuideReviewPage';
import { AdminIdentityCardEditorPage } from '@/features/admin/pages/AdminIdentityCardEditorPage';
import { AdminTravelersPage } from '@/features/admin/pages/AdminTravelersPage';
import { AdminGuidesPage } from '@/features/admin/pages/AdminGuidesPage';
import { AdminBlogsPage } from '@/features/admin/pages/AdminBlogsPage';
import { AdminBlogEditorPage } from '@/features/admin/pages/AdminBlogEditorPage';
import { AdminSettingsPage } from '@/features/admin/pages/AdminSettingsPage';
import { AdminLiveCitiesPage } from '@/features/admin/pages/AdminLiveCitiesPage';
import { AdminBookingsPage } from '@/features/admin-bookings/pages/AdminBookingsPage';
import { AdminGrowthPage } from '@/features/admin-growth/pages/AdminGrowthPage';
import {
  AdminFinancePage,
  AdminFinanceWithdrawalsRedirect,
  AdminFinanceSettlementsRedirect,
  AdminDisputesRedirect,
} from '@/features/admin-finance/pages/AdminFinancePage';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { RoleSurfaceGate } from '@/shared/components/RoleSurfaceGate';
import { Navigate } from 'react-router-dom';
import { ADMIN_ROUTES } from '@/features/admin/constants/routes';

export const adminRouteTree = {
  path: '/admin',
  element: (
    <RoleSurfaceGate surface="admin">
      <ProtectedRoute requireAdmin>
        <AdminDashboardLayout />
      </ProtectedRoute>
    </RoleSurfaceGate>
  ),
  children: [
    { index: true, element: <Navigate to={ADMIN_ROUTES.DASHBOARD} replace /> },
    { path: 'dashboard', element: <AdminDashboardPage /> },
    { path: 'onboarding', element: <AdminGuideOnboardingPage /> },
    // The two queues these replaced. Kept as redirects so existing bookmarks
    // land on the matching tab rather than a 404.
    {
      path: 'verification-queue',
      element: <Navigate to={ADMIN_ROUTES.onboarding('background_check')} replace />,
    },
    {
      path: 'review-queue',
      element: <Navigate to={ADMIN_ROUTES.onboarding('profile_review')} replace />,
    },
    { path: 'travelers', element: <AdminTravelersPage /> },
    { path: 'guides', element: <AdminGuidesPage /> },
    { path: 'bookings', element: <AdminBookingsPage /> },
    { path: 'blogs', element: <AdminBlogsPage /> },
    { path: 'blogs/new', element: <AdminBlogEditorPage /> },
    { path: 'blogs/:id/edit', element: <AdminBlogEditorPage /> },
    { path: 'live-cities', element: <AdminLiveCitiesPage /> },
    { path: 'finance', element: <AdminFinancePage /> },
    { path: 'growth', element: <AdminGrowthPage /> },
    { path: 'finance/withdrawals', element: <AdminFinanceWithdrawalsRedirect /> },
    { path: 'finance/settlements', element: <AdminFinanceSettlementsRedirect /> },
    { path: 'disputes', element: <AdminDisputesRedirect /> },
    { path: 'settings', element: <AdminSettingsPage /> },
    { path: 'guides/:id/review', element: <AdminGuideReviewPage /> },
    { path: 'guides/:id/identity-card', element: <AdminIdentityCardEditorPage /> },
  ],
};
